<template>
	<transition name="modal">
		<div class="modal-mask" @click="$emit('close')">
			<div class="modal-wrapper">
				<div class="modal-container" @click.stop>
					<div class="modal-header">
						<slot name="cross">
							<v-icon style="float: right; top: 2px;" @click="$emit('close')">mdi-close</v-icon>
						</slot>
					</div>

					<div class="modal-body">
						<div class="mb-6">
							<div class="titre"> {{ $t('_informations_') }} </div>
							<div v-if="linkedMpps.length === 0">
								{{ $t('_aucune_donnee_') }}
							</div>
							<ul v-else-if="currentPlane !== null" class="liste">
								<li>{{ $t('_pdm_') }} : {{ getNamesFromIds(linkedMpps).join(', ') }} </li>
								<li>{{ $t('_identifiant_rampant_') }} : {{ currentPlane.plane_id }}</li>
								<li>{{ $t('_orientation_') }} : {{ currentPlane.pv_orientation }}</li>
								<li>{{ $t('_inclinaison_') }} : {{ currentPlane.pv_inclination }}</li>
							</ul>
						</div>
						<div class="mb-6 cardDiv">
							<div class="titre">{{ $t('_liste_des_alarmes_') }}</div>
							<div v-if="linkedMpps.length === 0 && alarms.length ===0">
								{{ $t('_aucune_donnee_') }}
							</div>
							<div v-else-if="alarms.length === 0"> {{ $t('_aucune_alarme_non_traitee_') }}</div>
							<div v-else>
								<InstructionCard v-for="alarm in alarms" :key="alarm.id" :alarm="alarm"
									:answer="(matchAnswer(alarm))"
									:status="matchAnswer(alarm) === undefined ? 'To do' : matchAnswer(alarm).field_alarm_status"
									class="mt-5 card" @update="submitAnswer" @delete="update(alarm)"></InstructionCard>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>


<script>
import api from '@/api/api';
import InstructionCard from './InstructionCard.vue';
import backend from '@/api/backend';

export default {
	components: { InstructionCard },

	props: {
		linkedMpps: {
			required: true
		},
		alarms: {
			required: true
		},
		answers: {
			required: true
		},
		idBloc: {
			required: true
		}
	},

	async mounted() {
		try {
			let res = await api.get_all_full_layout(this.installation_id)
			this.mpps = res.data
			this.mpps.forEach(mpp => {mpp["id"]=mpp.mpp});
			res = await api.get_all_plane_information(this.installation_id)
			this.planes = res.data
		}
		catch {
			const res = (await backend.get_install_form(this.installation_id)).data

			const inventaireRampants = res.rampants_inventory
			this.planes = []
			for (const idRampant in inventaireRampants) {
				const json = {}
				json["plane_id"] = inventaireRampants[idRampant].id
				json["pv_inclination"] = inventaireRampants[idRampant].inclinaisonPV
				json["pv_orientation"] = inventaireRampants[idRampant].orientationPV
				json["installation_type"] = inventaireRampants[idRampant].installationChoisie
				if (inventaireRampants[idRampant].batChoisi !== "") {
					json["building_type"] = inventaireRampants[idRampant].batChoisi
				}
				else {
					json["building_type"] = "N/A"
				}
				if (inventaireRampants[idRampant].integrationChoisie !== "") {
					json["integration_type"] = inventaireRampants[idRampant].integrationChoisie
				}
				else {
					json["integration_type"] = "N/A"
				}
				
				this.planes.push(json)
			}
			const historique = res.history
			const calepinage = res.layouts
			this.mpps = []
			for (const idLigne in calepinage) {
				const json = {}
				json["init_module_nb"] = calepinage[idLigne].initNbModule
				json["init_string_nb"] = calepinage[idLigne].initNbChaine
				for (let idOnduleur in historique) {
					if (historique[idOnduleur].nom === calepinage[idLigne].idOnduleur)
						json["inv_model"] = historique[idOnduleur].type
				}
				json["module_nb"] = calepinage[idLigne].nbModule
				json["mpp"] = calepinage[idLigne].nom
				json["plane_id"] = calepinage[idLigne].idRampant
				json["pv_model"] = calepinage[idLigne].typeModule
				json["string_nb"] = calepinage[idLigne].nbChaine
				json["id"]= calepinage[idLigne].cleMpp
				this.mpps.push(json)
			}

		}


		if(this.linkedMpps.length!==0)
		this.getInfo()
	},

	data() {
		return {
			installation_id: this.$route.params.id,
			mpps: [],
			planes: [],
			currentMpp: null,
			currentPlane: null,
		}
	},

	methods: {
		getInfo() {
			this.currentMpp = this.mpps.find(element => element.id === this.linkedMpps[0]);
			this.currentPlane = this.planes.find(plane => plane.plane_id === this.currentMpp.plane_id);
		},
		submitAnswer(alarmIndex, updatedAnswer) {
			this.answers[this.getAnswerIndex(alarmIndex)] = { "id": alarmIndex, 'json_data': {} }
			this.$set(this.answers[this.getAnswerIndex(alarmIndex)], 'json_data', updatedAnswer);
			this.$forceUpdate()
			this.$emit('update')
		},
		matchAnswer(alarm) {
			let id = alarm.id
			for (var answer in this.answers) {
				if (this.answers[answer].id === id) {
					return this.answers[answer].json_data
				}
			}
		},
		getAnswerIndex(alarmId) {
			for (var answer in this.answers) {
				if (this.answers[answer].id === alarmId) {
					return answer
				}
			}
		},
		update(alarm) {
			const indexAlarme = this.alarms.indexOf(alarm)
			this.alarms.splice(indexAlarme,1)
			const indexReponse = this.getAnswerIndex(alarm.id)
			this.answers.splice(indexReponse,1)
			this.$emit('update')
		},
		getNamesFromIds(ids){
      let names=[]
      this.mpps.forEach((mpp) => {
        if(ids.includes(mpp.id))
          names.push(mpp.mpp)
      })
      return names
    },
	}
}
</script>

<style scoped>
.modal-container {
	width: fit-content;
	width: 95vw;
	height: 65vh;
	margin: 0px auto;
	padding: 2vh;
	background-color: rgba(255, 255, 255, 1);
	border-radius: 2px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
	transition: all 0.3s ease;
	border-radius: 0.25rem;
	position: relative;

}

.modal-header {
	font-weight: bold;
	font-size: 1.4rem;
}

.modal-body {
	margin: 1vw;
	flex-wrap: wrap;
}

.liste {
	list-style: none;
}

.titre {
	font-size: larger;
}

.card {
	border-width: 1px;
	border-color: rgb(185, 185, 185);
	border-style: solid;
	border-radius: 5px;
	margin-bottom: 5px;
}

.cardDiv {
	max-height: 40vh;
	/* hauteur fixe */
	overflow-y: auto;
	/* scroll vertical */
	padding: 10px;
}
</style>